export default {
  all: {
    id: 'bo_seller_global_select_market_option_all',
    defaultMessage: 'All',
  },
  label: {
    id: 'bo_seller_global_select_market_label',
    defaultMessage: 'Market',
  },
}
